import { clsx } from 'clsx';

import './icons.css';
import { FontIconNamesUnion } from '@monoimin/sb-types';

export interface FontIconsProps {
  icon: FontIconNamesUnion | undefined;
  [k: string]: any;
}

const iconUnicodeMap: Record<FontIconNamesUnion, string> = {
  download: '\u0420',
  arrowLeft: '\u0421',
  arrowRight: '\u0422',
  arrowDown: '\u0423',
  showMore: '\u0424',
  none: 'none',
};

export const FontIcons = ({ className, icon, ...props }: FontIconsProps) => {
  if (!icon || icon === 'none') {
    return null;
  }
  const unicode = iconUnicodeMap[icon];

  if (!unicode) {
    console.warn(`Icon "${icon}" not found in iconUnicodeMap.`);
    return null;
  }

  return (
    <span
      {...props}
      className={clsx('font-icon', className)}
      data-icon={unicode}
    />
  );
};
